import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import PrivacyPolicy from '../components/legal/PrivacyPolicy';
import { updatePageSEO } from '../utils/seo';

const PrivacyPolicyPage = () => {
  const navigate = useNavigate();

  // Update SEO tags when component mounts
  useEffect(() => {
    updatePageSEO({
      title: 'Privacy Policy - PlanLens.ai | Your Data, Your Control',
      description: 'Learn how PlanLens.ai protects your financial data. Read our privacy policy covering data collection, usage, security, and your rights. GDPR and CCPA compliant.',
      canonical: 'https://planlens.ai/privacy'
    });
  }, []);

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <nav className="bg-white border-b border-gray-200 sticky top-0 z-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-16">
            <div className="flex items-center space-x-3">
              <div className="w-10 h-10 bg-gradient-to-r from-blue-600 to-purple-600 rounded-xl flex items-center justify-center">
                <svg viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" className="w-6 h-6">
                  <polyline points="22 7 22 1 16 1"></polyline>
                  <polyline points="22 1 13 10 8 5 1 12"></polyline>
                </svg>
              </div>
              <span className="text-xl font-bold text-gray-900">PlanLens AI</span>
            </div>
            <button
              onClick={() => navigate('/')}
              className="flex items-center space-x-2 text-gray-700 hover:text-blue-600 font-medium transition"
            >
              <ArrowLeft className="w-4 h-4" />
              <span>Back to Home</span>
            </button>
          </div>
        </div>
      </nav>

      {/* Privacy Policy Content */}
      <div className="max-w-4xl mx-auto py-12 px-4 sm:px-6 lg:px-8">
        <PrivacyPolicy standalone={true} />
      </div>
    </div>
  );
};

export default PrivacyPolicyPage;
